export const BUNDLE_ASK_URL_WHITE_COLLAR_GAMER =
  "https://bundleaistudio.bundle.app/chat/t1bht3submelyy4xjd2/samsung-galaxy-z-fold6";

export const BUNDLE_ASK_URL_WOMAN =
  "https://bundleaistudio.bundle.app/chat/zjedvelnw5lyy506ub/samsung-galaxy-z-flip6";
